import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Announcement from '../components/Announcement';
import About from '../components/About';
import Services from '../components/Services';
import Stones from '../components/Stones';
import Projects from '../components/Projects';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Cherry Stone';
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Announcement />
      <About />
      <Services />
      <Stones />
      <Projects />
      <Clients />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default HomePage;
